<template>
  <section id="admin-filter">
    <h4>Accessorials filter</h4>
    <div class="form-group">
      <label for="description" class="form-label">Description</label>
      <input type="text" class="form-control" id="description" v-model="entity.description" />
    </div>
    <div class="form-group">
      <label class="form-label">Pre Carriage Location</label>
      <autocomplete
              :dataset="locationSearchResults"
              title="Location"
              placeHolder="Type to search"
              :initVal="entity.preCarriageLocation"
              v-on:changing="data => locationSearchText = data"
              :fnFormatText="displayLocation"
              :fnSelectValue="displayLocation"
              v-on:selection-made="selectPreCarriageLocation"
      />
    </div>
    <div class="form-group">
      <label for="precarriage-country" class="form-label">Pre Carriage Country</label>
      <select class="form-control" id="precarriage-country" v-model="entity.preCarriageCountry">
        <option value=""></option>
        <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label class="form-label">Origin Location</label>
      <autocomplete
        :dataset="locationSearchResults"
        title="Location"
        placeHolder="Type to search"
        :initVal="entity.originLocation"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectOrigin"
      />
    </div>
    <div class="form-group">
      <label for="origin-country" class="form-label">Origin Country</label>
      <select class="form-control" id="origin-country" v-model="entity.originCountry">
        <option value=""></option>
        <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label class="form-label">Destination Location</label>
      <autocomplete
              :dataset="locationSearchResults"
              title="Location"
              placeHolder="Type to search"
              :initVal="entity.destinationLocation"
              v-on:changing="data => locationSearchText = data"
              :fnFormatText="displayLocation"
              :fnSelectValue="displayLocation"
              v-on:selection-made="selectDestinationLocation"
      />
    </div>
    <div class="form-group">
      <label for="destination-country" class="form-label">Destination Country</label>
      <select class="form-control" id="destination-country" v-model="entity.destinationCountry">
        <option value=""></option>
        <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label class="form-label">On Carriage Location</label>
      <autocomplete
              :dataset="locationSearchResults"
              title="Location"
              placeHolder="Type to search"
              :initVal="entity.onCarriageLocation"
              v-on:changing="data => locationSearchText = data"
              :fnFormatText="displayLocation"
              :fnSelectValue="displayLocation"
              v-on:selection-made="selectOnCarriageLocation"
      />
    </div>
    <div class="form-group">
      <label for="oncarriage-country" class="form-label">On Carriage Country</label>
      <select class="form-control" id="oncarriage-country" v-model="entity.onCarriageCountry">
        <option value=""></option>
        <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="lookup-type" class="form-label">Lookup Type</label>
      <select v-model="entity.lookupType" class="form-control" id="lookup-type">
        <option value=""></option>
        <option v-for="(opt, i) in getSystemOptions('LOOKUP_TYPE')" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="mode" class="form-label">Mode</label>
      <select v-model="entity.mode" class="form-control" id="mode">
        <option value=""></option>
        <option v-for="(opt, i) in getSystemOptions('MODE')" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="container-type" class="form-label">Container Type</label>
      <select v-model="entity.containerType" class="form-control" id="container-type">
        <option value=""></option>
        <option v-for="(opt, i) in getSystemOptions('CONTAINER_TYPE')" :value="opt.id">{{ opt.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="is-suspended" class="form-label">Suspended?</label>
      <select class="form-control" id="is-suspended" v-model="entity.suspended">
        <option value=""></option>
        <option value="1">True</option>
        <option value="0">False</option>
      </select>
    </div>
    <div class="form-group">
      <label for="advice-only" class="form-label">Advice Only?</label>
      <select class="form-control" id="advice-only" v-model="entity.adviceOnly">
        <option value=""></option>
        <option value="1">True</option>
        <option value="0">False</option>
      </select>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  export default {
    name: 'AccessorialFilter',
    mixins: [ FilterMixin, HelperMixin ],
    data () {
      return {
        entity: {
          description: '',
          preCarriageLocation: '',
          preCarriageCountry: '',
          originLocation: '',
          originCountry: '',
          destinationLocation: '',
          destinationCountry: '',
          onCarriageLocation: '',
          onCarriageCountry: '',
          mode: '',
          containerType: '',
          adviceOnly: null,
          suspended: null
        }
      }
    },
    components: {
      Autocomplete
    },
    methods: {
      selectOrigin (o) {
        this.entity.originLocation = o
        this.clearLocationText()
      },
      selectDestinationLocation (o) {
        this.entity.destinationLocation = o
        this.clearLocationText()
      },
      selectPreCarriageLocation (o) {
        this.entity.preCarriageLocation = o
        this.clearLocationText()
      },
      selectOnCarriageLocation (o) {
        this.entity.onCarriageLocation = o
        this.clearLocationText()
      },
      clearLocationText () {
        this.locationSearchText = ''
        this.locationSearchResults = []
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AccessorialFilter.vue?29a10a71